import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';

const Form = props => (
	<form
		onSubmit={props.handleSubmit(data => {
			props.updateComment( props.requestId, data).then(() => props.setActiveRow(null));
		})}
	>
		<div className="control-bar-container">
			<div className='banners-publication-editor-field'>
				<Field
					name='comment'
					component={InputField}
					placeholder={props.intl('Comment')}
				/>
			</div>
		</div>
		<button type="submit" className="ui-btn ui-btn-primary save margin-top-15">
			{props.intl('Update')}
		</button>
	</form>
);

export default reduxForm({})(Form);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/daily-approves-list/components/forms/update-daily-approve-comment.js